import { ExternalLink } from '@localstack/constants';
import { Alert, Link } from '@mui/material';
import { ReactElement } from 'react';

const LICENSE_DOCS_URL = `${ExternalLink.DOCS_AUTH_TOKEN}#configuring-your-auth-token`;

export const LicenseAlert = (): ReactElement => (
  <Alert severity="warning">
    Could not connect to a licensed LocalStack instance. The running LocalStack container may be using an outdated or
    unsupported image version.{' '}
    <Link href={LICENSE_DOCS_URL} target="_blank" rel="noreferrer" color="inherit" underline="always">
      Learn how to upgrade LocalStack and configure your license
    </Link>
  </Alert>
);
